type SpindlLogoInternalProps = {
};

type SpindlLogoPropsValues = {
  '': SpindlLogoInternalProps;
};

const propValues: SpindlLogoPropsValues = {
  '': {
  },
};

const getProps = (type: string): SpindlLogoInternalProps => {
  const values: SpindlLogoInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
